// extracted by mini-css-extract-plugin
module.exports = {"responsiveWrapper":"IFrame_responsiveWrapper__2ldwL","responsiveIFrame":"IFrame_responsiveIFrame__1dD-z"};